import React, { useEffect } from 'react';
import { ConcreteFinishesHero } from '../components/concrete-finishes/ConcreteFinishesHero';
import { FinishOptionsSection } from '../components/concrete-finishes/FinishOptionsSection';
import { ApplicationGuideSection } from '../components/concrete-finishes/ApplicationGuideSection';
import { HeatedSlabSection } from '../components/concrete-finishes/HeatedSlabSection';
import { DurabilitySection } from '../components/concrete-finishes/DurabilitySection';
import { CostFactorsSection } from '../components/concrete-finishes/CostFactorsSection';
import { FinishDecisionGuide } from '../components/concrete-finishes/FinishDecisionGuide';
import { ConcreteFinishesCTA } from '../components/concrete-finishes/ConcreteFinishesCTA';
export function ConcreteFinishesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background font-sans antialiased" data-id="element-1249">
      <main data-id="element-1250">
        <ConcreteFinishesHero data-id="element-1251" />
        <FinishOptionsSection data-id="element-1252" />
        <ApplicationGuideSection data-id="element-1253" />
        <HeatedSlabSection data-id="element-1254" />
        <DurabilitySection data-id="element-1255" />
        <CostFactorsSection data-id="element-1256" />
        <FinishDecisionGuide data-id="element-1257" />
        <ConcreteFinishesCTA data-id="element-1258" />
      </main>
    </div>;
}